import React, { memo } from 'react';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import { Bg_3Grid, Main_3Grid, Bg_6Grid, Main_3_5Grid, Main_2Grid } from './components';

const defaultProps = {
  containerStyle: {},
  data: {}
};

const propTypes = {
  data: PropTypes.object,
  containerStyle: PropTypes.object
};

const ClassifyCell = memo((props) => {
  const {
    data, // Object 数据
    containerStyle // Object 容器样式
  } = props;

  const renderItem = () => {
    const {
      displayType // displayType: 0:背景+3宫格， 1: 主图+3宫格， 2: 主图+4宫格 -> 主图+3.5宫格， 3: 背景+6宫格  4: 三宫格 -> 背景+3宫格 5: 主图+3.5宫格 6: 主图+2宫格
    } = data;
    switch (displayType) {
      case 0:
        return <Bg_3Grid {...props} />;
      case 1:
        return <Main_3Grid {...props} />;
      case 2:
        return <Main_3_5Grid {...props} />;
      case 3:
        return <Bg_6Grid {...props} />;
      case 4:
        return <Bg_3Grid {...props} />;
      case 5:
        return <Main_3_5Grid {...props} />;
      case 6:
        return <Main_2Grid {...props} />;
      default:
        return null;
    }
  };

  return <Flex style={containerStyle}>{renderItem()}</Flex>;
});

ClassifyCell.defaultProps = defaultProps;
ClassifyCell.propTypes = propTypes;

export default ClassifyCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/ClassifyCell/index.js